module.exports = __webpack_public_path__ + "static/queimador-de-plasma-0e78fc168173f23f8f223555faa10a0d.png";